export const DMM_SERVICE_MENU = {
  OTHER_SERVICE: "その他サービス",
  FOR_BUSINESS: "ビジネス・法人向け",
};
